import { SelectCode } from "@corporate-tailwind/model";
import { OrderStatusDto } from "./order-status.model";

export class OrderHistoryDto {
    id: number | null = null;
    status: OrderStatusDto | null = null;
    dateCreate: Date | null = null;
 
}